import { render, staticRenderFns } from "./UserShifts.vue?vue&type=template&id=1294d74b"
import script from "./UserShifts.vue?vue&type=script&lang=js"
export * from "./UserShifts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports